export default {"src":"/_next/static/media/coco-sad.c2f71d5c.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};